
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic01Static as ObiHydraulic01StaticElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-01-static.js';
 
 
 

 
 export const ObiHydraulic01Static = createComponent({
   react: React,
   tagName: 'obi-hydraulic-01-static',
   elementClass: ObiHydraulic01StaticElement,
   events: {
     
   }
  });
 
 